<template>
	<div>
		<PersonalBanner />
		<div class="content-zsy">
	
			<div class="type-card">
				<div class="card-body">
					<h5><span class="num">01.</span><div class="content">고로켓고 신규가입 축하 8종 쿠폰을 모두 드립니다.</div></h5>
					<p class="mb50">
	                    신규 회원님의 배송비 부담을 줄여드리기 위한 신규 회원님만의 고로켓고 혜택입니다.
	                </p>
					<el-row style="padding:10px 0;">
						<el-col :xs="12" :sm="6">
							<div class="img-box">
								<img loading="lazy" v-if="isMobile" src="../../assets/list/Group 5.png" alt="" class="img-responsive">
								<img loading="lazy" v-else src="../../assets/list/Group 5.png" alt="" class="img-responsive ">
							</div>
						</el-col>
						<el-col :xs="12" :sm="6">
							<div class="img-box">
								<img loading="lazy" v-if="isMobile" src="../../assets/list/Group 6.png" alt="" class="img-responsive">
								<img loading="lazy" v-else src="../../assets/list/Group 6.png" alt="" class="img-responsive ">
							</div>
						</el-col>
						<el-col :xs="12" :sm="6">
							<div class="img-box">
								<img loading="lazy" v-if="isMobile" src="../../assets/list/Group 9.png" alt="" class="img-responsive">
								<img loading="lazy" v-else src="../../assets/list/Group 9.png" alt="" class="img-responsive ">
							</div>
						</el-col>
						<el-col :xs="12" :sm="6">
							<div class="img-box">
								<img loading="lazy" v-if="isMobile" src="../../assets/list/Group 7.png" alt="" class="img-responsive">
								<img loading="lazy" v-else src="../../assets/list/Group 7.png" alt="" class="img-responsive ">
							</div>
						</el-col>
					</el-row>
					
					<h5><span class="num">02.</span><div class="content">고로켓고 이용 실적에 따른 할인 혜택입니다.</div></h5>
					<div class="grade-title">고로켓고 회원등급</div>
					
					<div class="table-wrapper mb60">
						<!-- Desktop Table -->
						<table class="table-grade dark-theme hidden-xs">
							<thead>
							<tr>
								<th class="radius-left"></th>
								<th class="text-center">개인일반회원</th>
								<th class="text-center">개인파트너회원</th>
								<th class="text-center">사업자일반회원</th>
								<th class="text-center radius-right">사업자파트너회원</th>
							</tr>
							</thead>
							<tbody>
							<tr>
								<td class="text-center label-td">거래건수</td>
								<td class="text-center">0~99건</td>
								<td class="text-center">100건 이상</td>
								<td class="text-center">0~499건</td>
								<td class="text-center">500건 이상</td>
							</tr>
							<tr>
								<td class="text-center label-td">배송비 할인</td>
								<td class="text-center" colspan="4">해당 등급으로 할인 적용</td>
							</tr>
							</tbody>
						</table>

						<!-- Mobile Table -->
						<table class="table-grade dark-theme visible-xs">
							<thead>
							<tr>
								<th class="radius-left"></th>
								<th class="text-center">개인일반</th>
								<th class="text-center radius-right">개인파트너</th>
							</tr>
							</thead>
							<tbody>
							<tr>
								<td class="text-center label-td">건수</td>
								<td class="text-center">0~99건</td>
								<td class="text-center">100건+</td>
							</tr>
							</tbody>
							<thead class="mobile-divider">
							<tr>
								<th class="radius-left"></th>
								<th class="text-center">사업자일반</th>
								<th class="text-center radius-right">사업자파트너</th>
							</tr>
							</thead>
							<tbody>
							<tr>
								<td class="text-center label-td">건수</td>
								<td class="text-center">0~499건</td>
								<td class="text-center">500건+</td>
							</tr>
							<tr>
								<td class="text-center label-td">할인</td>
								<td class="text-center" colspan="2">등급별 할인 적용</td>
							</tr>
							</tbody>
						</table>
					</div>
					<div class="divided-line"></div>
					<ul class="check-list">
						<li>고로켓고 이용 실적은 배송비 결제 건수에 따라 등급이 자동 적용되어 할인 적용됩니다.</li>
						<li>합배송(신청서 합치기)는 이용실적 1건으로 적용됩니다.</li>
						<li>신규 가입 쿠폰 및 회원 등급 정책은 당사 정책의 의해 변경될 수 있습니다.</li>
						<li>배송비 결제건 이 외는 이용 실적에 포함되지 않습니다.</li>
						<li>배송비 결제 시 보유하신 할인쿠폰을 최대 1장 최고 15% 할인까지 할인이 가능합니다</li>
						<li>모든 쿠폰은 중복사용 불가능합니다.</li>
						<li>쿠폰의 유효기간은 발급일로부터 최대30일까지 입니다.</li>
						<li>LCL/FCL 화물운송의 경우 모든 쿠폰적용 불가합니다.</li>
					</ul>
						
				</div>
			
			</div>
			
		</div>
		<div style="text-align: center;"  v-if="!isLoggedIn">
			<router-link to="/register" class="register-button">
				회원가입<i class="el-icon-arrow-right"></i>
			</router-link>
		</div>
		
	</div>
</template>

<script>
	import PersonalBanner from '../../components/PersonalBanner.vue'
	import { mapGetters } from 'vuex';
	export default {
		name: 'documentbenefit',
		components: {
			PersonalBanner
		},
		data() {
			return{
				
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			},
			...mapGetters(['isLoggedIn']),
		},	
		methods: {
			onCurrentNav(url){
				this.$router.push(url);
			}
		}

		
		
	}
	
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: #111;
		margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    margin: 0 0 19px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
		color: var(--frontground-color);
	    margin: 0;
	}
	.type-card{
		border: none;
		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
		border-radius: 26px;
		overflow: hidden;
		margin-bottom: 90px !important;
	}
	.card-body{
		background: #fff;
		padding: 26px 36px;
	}
	.card-body .num{
		color: var(--main-color);
		
	}
	.card-body h5{
		margin: 0;
		font-weight: 700;
		font-size: 24px;
		display: flex;
		align-items: center;
		gap: 0 5px;
	}
	.card-body h6{
		margin: 0;
		font-weight: 700;
		font-size: 20px;
		display: flex;
		align-items: center;
		gap: 0 5px;
		padding: 10px 0;
	}
	.mb50{
		padding-bottom: 10px;
	}
	.img-box{
		display: flex;
		justify-content: center;
		padding-bottom: 20px;
	}
	.img-responsive{
		display: block;
		max-width: 100%;
		height: auto;
	}
	
	.grade-title {
		font-weight: 700;
		font-size: 20px;
		color: #111;
		margin: 40px 0 20px;
	}

	/* table表格 */
	.table-wrapper {
	    border-radius: 12px;
	    overflow: hidden;
	    box-shadow: 0 4px 20px rgba(0,0,0,0.1);
		border: none;
	}
	.table-grade {
	    width: 100%;
	    table-layout: fixed;
	    border-collapse: separate;
	    border-spacing: 0;
		background: #ffffff;
	}
	.table-grade thead th {
	    background: rgb(247, 148, 29);
	    font-weight: 700;
	    font-size: 15px;
	    color: #FFFFFF;
	    padding: 16px;
		border: none;
	}
	.table-grade tbody td {
	    border: 1px solid #eee;
	    font-size: 14px;
	    padding: 14px;
	    line-height: normal;
		color: #333;
	}
	.table-grade .label-td {
		background: #fcfcfc;
		color: #111 !important;
		font-weight: 700;
	}
	
	.radius-left {
		border-radius: 12px 0 0 12px;
	}
	.radius-right {
		border-radius: 0 12px 12px 0;
	}
	.mobile-divider th {
		border-top: 10px solid #fff !important;
	}
	
	.type-card .divided-line {
	    border-top: 1px dashed var(--border-color);
	    margin: 26px 0;
	}
	ul.check-list {
	    margin: 0;
	    padding: 0;
	    list-style: none;
	}

	ul.check-list li {
		margin-top: 12px;
	    padding-left: 26px;
	    background: url(../../assets/ico_check_grey.svg) no-repeat left 2px top 4px;
	    font-weight: 400;
	    font-size: 15px;
	    line-height: 23px;
	}
	.visible-xs {
	    display: none !important;
	}
	.register-button{
		display: inline-flex;
		justify-content: center;
		align-items: center;
		gap: 10px;
		min-width: 180px;
		margin-bottom: 40px;
		height: 64px;
		border: 1px solid var(--main-color);
		background: var(--main-color);
		border-radius: 36px;
		font-weight: 500;
		font-size: 17px;
		text-decoration: none !important;
		color: #fff !important;
		transition: 0.25s;
		cursor: pointer;
	}
	.content,h6,td.text-center,ul.check-list li {
		color: var(--background-color);
	}
	
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 992px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.card-body{
			padding: 26px;
		}
		.card-body h5{		
			font-size: 16px;
		}
		.card-body h6{
			font-size: 12px;
		}
		.mb50{
			font-size: 12px;
		}
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;
			color: #0055D4;
			font-weight: bold;
			line-height: 23px;
		}
		.title-wrap h4 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
		}
		

		.table-type-card thead th {		
		    font-size: 13px;
			
		}
	
		.img-responsive{	
			max-width: 90%;
		}
		.visible-xs {
		    display:block !important;
		}
		.hidden-xs {
			display: none !important;
		}
	}
</style>